import shareMap from './share';
const importExt = function(name) {
    let a = shareMap[name];
    if (!a) {
        throw new Error(`${name} module not found`);
    }
    return a;
};
export default importExt;
